function isWhitespaceTextNode(node: ChildNode): boolean {
  return node.nodeType === Node.TEXT_NODE && !(node.textContent || '').trim();
}

function isBreakElement(node: ChildNode): node is HTMLBRElement {
  return node.nodeType === Node.ELEMENT_NODE && (node as Element).tagName === 'BR';
}

function getTrailingBreaksWithContentInfo(paragraph: HTMLParagraphElement): {
  trailingBreaks: HTMLBRElement[];
  hasMeaningfulContent: boolean;
} {
  const trailingBreaks: HTMLBRElement[] = [];
  let cursor: ChildNode | null = paragraph.lastChild;

  while (cursor) {
    if (isWhitespaceTextNode(cursor)) {
      cursor = cursor.previousSibling;
      continue;
    }

    if (isBreakElement(cursor)) {
      trailingBreaks.unshift(cursor);
      cursor = cursor.previousSibling;
      continue;
    }

    return { trailingBreaks, hasMeaningfulContent: true };
  }

  return { trailingBreaks, hasMeaningfulContent: false };
}

function createEmptyParagraph(source: HTMLParagraphElement): HTMLParagraphElement {
  const emptyParagraph = source.ownerDocument.createElement('p');
  const style = source.getAttribute('style');

  if (style) {
    emptyParagraph.setAttribute('style', style);
  }

  return emptyParagraph;
}

export function normalizeOutgoingMessageHtml(input: string): string {
  if (!input?.includes('<br')) {
    return input;
  }

  const container = document.createElement('div');
  container.innerHTML = input;

  const paragraphs = Array.from(container.querySelectorAll('p'));

  paragraphs.forEach((paragraph) => {
    const { trailingBreaks, hasMeaningfulContent } =
      getTrailingBreaksWithContentInfo(paragraph);

    if (!trailingBreaks.length || !hasMeaningfulContent) {
      return;
    }

    trailingBreaks.forEach((br) => br.remove());

    const parent = paragraph.parentNode;
    if (!parent) {
      return;
    }

    const referenceNode = paragraph.nextSibling;

    trailingBreaks.forEach(() => {
      const emptyParagraph = createEmptyParagraph(paragraph);
      parent.insertBefore(emptyParagraph, referenceNode);
    });
  });

  return container.innerHTML;
}
